import React, { Component } from 'react';
import InlineSVG from 'svg-inline-react';
import { connect } from 'react-redux';
import { openDrawer, closeDrawer } from 'actions/drawer';
import { addNotification } from 'actions/notifications';

import { Customer } from 'models';
import { validate } from 'models/validate';

import ContentHeader from './ContentHeader';
import ContentFooter from './ContentFooter';

import { PanelSection, PanelSectionWithLabel } from 'components/PanelSections';

import AccountInfo from 'components/AccountInfo';
import UserListPanel from 'components/UserListPanel';
import OrderListPanel from 'components/OrderListPanel';
import SchoolListPanel from 'components/SchoolListPanel';

import Input from './Input';

import { setObjPath } from '../util';

class CustomerPanel extends Component {

	constructor (props) {
		super(props);
		let products = this.props.customer.orders ? this.props.getProductsForCustomer(this.props.customer) : [];

		let customer = this.props.customer;

		if(customer && !customer.users) {
			customer.users = {};
		}

		if(customer && !customer.schools) {
			customer.schools = {};
		}

		this.state = {
			customer : this.props.customer,
			orders : this.props.customer.orders,
			products : products
		};
	}

	updateCustomer (event) {
		let customer = setObjPath(this.state.customer, event.target.name, event.target.value);
		this.setState({
			customer: customer
		});
	}

	addUserToCustomer (userId) {
		let customer = this.state.customer;
		customer.users[userId] = true;
		this.setState({
			customer : customer
		});
	}

	removeUserFromCustomer(userId) {
		let customer = this.state.customer;
		delete customer.users[userId];
		this.setState({
			customer : customer
		});
	}

	toggleActive (event) {
		let customer = setObjPath(this.state.customer, event.target.name, event.target.value);

		if(event.target.checked) {
			customer.active = true;
			customer.dateActivated = new Date().getTime();
		} else {
			customer.active = false;
			customer.dateActivated = null;
		}

		this.setState({
			customer: customer
		});
	}

	render () {
		return (
			<div className="panel">
				<ContentHeader
					title={this.props.title}
					closeable="true"
					onClose={this.props.closeDrawer}
				/>
				<div className="panel-content">
					<div className="container">

						{/*Name*/}
						<PanelSectionWithLabel label="Customer Name">
							<Input
								inputClass="large"
								placeholder="Customer Name"
								name="name"
								value={this.state.customer.name || ''}
								onChange={this.updateCustomer.bind(this)}
							/>
						</PanelSectionWithLabel>

						{/*need a way to activate*/}
						{/*<PanelSectionWithLabel label="Active">*/}
							{/*<div className="panel-row">*/}
							{/*<Input*/}
								{/*type="toggle"*/}
								{/*name="active"*/}
								{/*checked={this.state.customer.active}*/}
								{/*value={this.state.customer.active}*/}
								{/*offLabel="Off"*/}
								{/*onLabel="On"*/}
								{/*onChange={this.toggleActive.bind(this)}*/}
							  {/*/>*/}
							  {/*</div>*/}
						{/*</PanelSectionWithLabel>*/}

						<AccountInfo
							customer={this.state.customer}
							updateCustomer={this.updateCustomer.bind(this)}
						/>

						{/*Users*/}
						{/*<PanelSection header="Users">*/}
							{/*{this.props.editing ? (*/}
							{/*<UserListPanel*/}
								{/*customer={this.state.customer}*/}
								{/*addUserToCustomer={this.props.addUserToCustomer}*/}
								{/*removeUserFromCustomer={this.props.removeUserFromCustomer}*/}
							{/*/>*/}
							{/*) : <UserListPanel*/}
								{/*customer={this.state.customer}*/}
								{/*addUserToCustomer={this.addUserToCustomer.bind(this)}*/}
								{/*removeUserFromCustomer={this.removeUserFromCustomer.bind(this)}*/}
							{/*/> }*/}
						{/*</PanelSection>*/}

						{/*Orders*/}
						<PanelSection header="Orders">
							<OrderListPanel
								products={this.state.products}
								customer={this.state.customer}
							/>
						</PanelSection>

						{/*Schools*/}
						{this.props.editing ?
							(<PanelSection header="Schools">
								<SchoolListPanel
									products={this.state.products}
									customer={this.state.customer}
									orders={this.state.orders}
								/>
							</PanelSection>)
							: false }
					</div>
				</div>
				<ContentFooter
					onClose={this.props.closeDrawer}
					onCancel={this.props.onCancel}

					onConfirm={function(){
						validate(this.state.customer, Customer).then( (validatedCustomer)=> {
							if(this.props.editing) {
								this.props.saveCustomer(validatedCustomer);
								this.props.addNotification('add-save-customer-success-' + Date.now(), 'Customer Saved');
							} else {
								this.props.addCustomer(validatedCustomer);
								this.props.addNotification('add-save-customer-success-' + Date.now(), 'Customer Added');
								this.props.closeDrawer();
							}

						}).catch( (error)=> {
							console.log(error.message);
							this.props.addNotification('add-save-customer-error-' + Date.now(), error.message);
						});

					}.bind(this)}
					cancelLabel={this.props.cancelLabel}
					confirmLabel='Save Customer'
				/>
			</div>
		);
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		openDrawer :  (panel) => { dispatch(openDrawer(panel)); },
		closeDrawer : () => { dispatch(closeDrawer()); },
		addNotification : (key, message) => { dispatch(addNotification(key, message)); }
	};
};

export default connect(
	null,
	mapDispatchToProps
)(CustomerPanel);




// WEBPACK FOOTER //
// ./js/components/CustomerPanel.js